import { Children } from 'react';
import warning from '@andes/common/build/utils/warning';
const hasChildNodes = _ref => {
  let {
    primary,
    children
  } = _ref;
  return primary && Children.count(children) > 0;
};
const itemNodeGenerator = function* getCollectionNode(props) {
  const {
    children,
    primary,
    title,
    'aria-label': ariaLabel
  } = props;
  const rendered = title || primary || children;
  const textValue = (typeof rendered === 'string' ? rendered : '') || ariaLabel || '';
  warning(textValue, '<ListItem> needs some plain text contents for accessibility reasons. Please add a `title` or `aria-label` prop.');
  yield {
    type: 'item',
    key: props.value,
    props,
    rendered,
    textValue,
    'aria-label': ariaLabel || title || primary,
    hasChildNodes,
    *childNodes() {
      if (primary || title) {
        const items = [];
        Children.forEach(children, child => {
          items.push({
            type: 'item',
            element: child
          });
        });
        yield* items;
      }
    }
  };
};
export { itemNodeGenerator as default };
